import { gql } from "@apollo/client";

const GET_ALL_UPLOAD_UNITS = gql`
  query getInvoiceUploadUnits(
    $missingClientIdentifier: Boolean
    $uploadUnitStatuses: [InvoiceUploadUnitStatus]
    $maxUnitsPerClient: Int
    $clientIdentifier: String
    $sortDirection: SortDirection
    $skip: Int
    $take: Int
  ) {
    clientInvoiceUploadUnits(
      missingClientIdentifier: $missingClientIdentifier
      uploadUnitStatuses: $uploadUnitStatuses
      maxUnitsPerClient: $maxUnitsPerClient
      clientIdentifier: $clientIdentifier
      sortDirection: $sortDirection
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        client {
          id
          name
          emailConnections {
            id
            clientIdentifier
            emailAddress
            modifiedAt
          }
          invoiceReaderTemplates {
            id
            name
            state
          }
          settings {
            product {
              defaultInvoiceServiceType
            }
          }
        }
        invoiceUploadUnits {
          id
          createdAt
          rejectionComment {
            createdByUser {
              id
              firstName
              lastName
            }
            content
            createdAt
            id
          }
          emailDetails {
            isHtml
            messageId
            previewBody
            rawBody
            receivedDate
            recipients
            sentFromEmail
            subject
          }
          invalidAttachments {
            contentType
            errorMessage
            fileName
          }
          invoiceDocuments {
            id
            invoiceRecipientEmails
            invoiceRecipientGln
            serviceType
            userMessage
            status
            file {
              fileType
              id
              fileName
            }
            relatedDocuments {
              id
              status
              file {
                fileType
                id
                fileName
              }
            }
            comments(skip: 0, take: 5) {
              totalCount
              items {
                content
                createdAt
                createdByUser {
                  id
                  firstName
                  lastName
                }
                id
              }
            }
          }
          isBlacklisted
          modifiedAt
          status
          statusHistory {
            setAt
            status
          }
          uploadSource
          uploadType
        }
      }
    }
  }
`;

export default GET_ALL_UPLOAD_UNITS;
